(() => {
  "use strict";

  // Each reasons section (.lg-five-reasons) is an independent carousel; the page may contain none, one or several.
  const setup = (section) => {
    if (section.dataset.carouselReady === "true") return;

    const track = section.querySelector(".lg-five-reasons-track");
    const cards = [...section.querySelectorAll(".lg-five-reason-card")];
    const previous = section.querySelector(".lg-carousel-arrow--prev");
    const next = section.querySelector(".lg-carousel-arrow--next");
    const dots = [...section.querySelectorAll(".lg-carousel-dot")];

    if (!track || !previous || !next || cards.length === 0 || dots.length !== cards.length) {
      throw new Error("Reasons carousel requires one track, two arrows, and one dot per card");
    }

    let activeIndex = 0;
    let programmaticScroll = false;
    let scrollFrame = 0;
    let unlockTimer = 0;

    const updateDots = () => {
      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
      track.setAttribute(
        "aria-label",
        `Gründe für Leichtgefühl; Grund ${activeIndex + 1} von ${cards.length}`,
      );
    };

    const showCard = (index, behavior = "smooth") => {
      if (!Number.isInteger(index) || index < 0 || index >= cards.length) {
        throw new RangeError(`Invalid reasons carousel index: ${index}`);
      }
      activeIndex = index;
      programmaticScroll = true;
      updateDots();
      const trackBounds = track.getBoundingClientRect();
      const cardBounds = cards[activeIndex].getBoundingClientRect();
      const targetLeft = track.scrollLeft + cardBounds.left - trackBounds.left;
      track.scrollTo({ left: targetLeft, behavior });
      window.clearTimeout(unlockTimer);
      unlockTimer = window.setTimeout(() => {
        programmaticScroll = false;
      }, behavior === "smooth" ? 1000 : 50);
    };

    const bindControl = (control, activate) => {
      control.addEventListener("pointerup", (event) => {
        event.preventDefault();
        activate();
      });
      control.addEventListener("click", (event) => {
        if (event.detail === 0) activate();
      });
    };

    bindControl(previous, () => showCard((activeIndex - 1 + cards.length) % cards.length));
    bindControl(next, () => showCard((activeIndex + 1) % cards.length));
    dots.forEach((dot, index) => bindControl(dot, () => showCard(index)));

    track.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        showCard((activeIndex - 1 + cards.length) % cards.length);
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        showCard((activeIndex + 1) % cards.length);
      }
    });

    track.addEventListener("scroll", () => {
      if (programmaticScroll) {
        window.clearTimeout(unlockTimer);
        unlockTimer = window.setTimeout(() => {
          programmaticScroll = false;
        }, 150);
        return;
      }
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = 0;
        const start = track.getBoundingClientRect().left;
        activeIndex = cards.reduce((closest, card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - start);
          return distance < closest.distance ? { index, distance } : closest;
        }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
        updateDots();
      });
    }, { passive: true });

    window.addEventListener("resize", () => showCard(activeIndex, "auto"));
    section.dataset.carouselReady = "true";
    updateDots();
  };

  document.querySelectorAll(".lg-five-reasons").forEach(setup);
  // The theme editor re-renders a section after each change; initialise the fresh markup.
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll(".lg-five-reasons").forEach(setup);
  });

  // CTA buttons ("Leichtgefühl™ auswählen" etc.) scroll up to the buy area. The main product section's id carries the
  // template hash, so it is looked up at click time (the theme re-renders that block on variant changes).
  if (!window.coreexLgOfferLinks) {
    window.coreexLgOfferLinks = true;
    document.addEventListener("click", (event) => {
      const link = event.target.closest("a[data-lg-offer-link]");
      if (!link) return;
      // <product-rerender> is display:contents (no layout box), so scroll to the .product wrapper inside it.
      const wrapper = document.querySelector('[id^="product-info-"]');
      const offer = wrapper && (wrapper.querySelector(".product") || wrapper.firstElementChild);
      if (!offer) return;
      event.preventDefault();
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      offer.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    });
  }
})();
